<template>
  <transition name="fade">
    <div
      class="popup"
      v-if="isVisible"
      ref="popup"
      @click.prevent.stop
    >
      <div class="popup__overlay" v-if="$slots.overlay">
        <slot name="overlay" />
      </div>
      <div class="popup__wrapper">
        <div class="popup__container" ref="popup-content">
          <header class="popup__header" v-if="$slots.header">
            <i
              slot="close"
              class="popup__close material-icons cl-bg-tertiary"
              @click.stop="close"
            >
              close
            </i>
            <slot name="header" />
          </header>
          <div class="popup__content" v-if="$slots.content">
            <slot name="content" />
          </div>
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import onEscapePress from '@vue-storefront/core/mixins/onEscapePress'

export default {
  name: 'Popup',
  props: {
    name: {
      required: true,
      type: String
    },
    delay: {
      type: Number,
      required: false,
      default: 300
    },
    overlay: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  mixins: [onEscapePress],
  data () {
    return {
      isVisible: false
    }
  },
  methods: {
    onHide (name) {
      return name === this.name ? this.toggle(false) : false
    },
    onShow (name) {
      return name === this.name ? this.toggle(true) : false
    },
    onToggle (name, state) {
      if (name === this.name) {
        state = typeof state === 'undefined' ? !this.isVisible : state
        this.toggle(state)
      }
    },
    onEscapePress () {
      this.close()
    },
    toggle (state) {
      this.isVisible = state;
    },
    close () {
      this.isVisible = false
      this.$emit('close')
    }
  },
  beforeMount () {
    this.$bus.$on('popup-toggle', this.onToggle)
    this.$bus.$on('popup-show', this.onShow)
    this.$bus.$on('popup-hide', this.onHide)
  },
  beforeDestroy () {
    this.$bus.$off('popup-toggle', this.onToggle)
    this.$bus.$off('popup-show', this.onShow)
    this.$bus.$off('popup-hide', this.onHide)
  }
}
</script>

<style lang="scss">
@import '~theme/css/layout/screen';
@import '~theme/css/base/global_vars';
$z-index-popup: map-get($z-index, popup);

.popup {
  position: absolute;
  z-index: $z-index-popup;
  width: 100%;
  bottom: 0;
  left: 0;
  transform: translateY(100%);

  &::before {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    left: 8px;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 20px solid white;
    z-index: 200;
  }

  &__overlay {
    position: fixed;
    z-index: 100;
  }

  &__wrapper {
    position: relative;
    border-radius: 12px;
    padding: 16px;
    background: white;
    margin-top: 12px;
    box-shadow: 1px 2px 7px 0 rgba(0, 0, 0, 0.13);
    z-index: 150;
  }

  &__container {
    width: 420px;

    @media only screen and (max-width: $screen-sm-l) {
      width: -webkit-fill-available;
    }
  }

  &__close {
    cursor: pointer;
  }

  &__header {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
    justify-content: space-between;

    > p {
      margin: 0;
    }
  }

  &__content {
    margin-top: 12px;
  }
}
</style>
